<template>
  <div class="page">
    <div class="page-header">
      <Back @click="$router.back()" />
      <span> Pengambilan Sertifikat </span>
    </div>

    <div class="body">
      <p class="info">Klik pada siswa yang sudah menerima sertifikat</p>

      <div style="text-align: center; padding-top: 100px" v-if="loading">
        <Loading />
      </div>

      <div v-show="data.length <= 0 && !loading">
        <p style="font-size: 14px; text-align: center; padding-top: 100px;">Tidak ada data</p>
      </div>

      <ul>
        <li
          v-for="(item, index) in data"
          :key="index"
          @click="ambilSertifikat(item)"
          :class="{ active: item.ambil_sertifikat == 1 }"
        >
          <div>
            {{ ++index }}
          </div>
          <div>
            <table>
              <tr>
                <td>No Kursi</td>
                <td>:</td>
                <td>{{ item.no_kursi }}</td>
              </tr>
              <tr>
                <td>No Daftar</td>
                <td>:</td>
                <td>{{ item.no_daftar }}</td>
              </tr>
              <tr>
                <td>Nama</td>
                <td>:</td>
                <td>{{ item.nama_lengkap }}</td>
              </tr>
              <tr>
                <td>Jurusan</td>
                <td>:</td>
                <td>{{ item.jurusan }}</td>
              </tr>
              <tr>
                <td>Angkatan</td>
                <td>:</td>
                <td>{{ item.angkatan_2 }}</td>
              </tr>
              <tr>
                <td>Kampus</td>
                <td>:</td>
                <td>{{ item.kampus }}</td>
              </tr>
            </table>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as api from "../api";
import moment from "moment";
import Back from "./../assets/Back.vue";
import Loading from "./../assets/Loading.vue";

export default {
  name: "app",
  data() {
    return {
      loading: false,
      loadingScan: false,
      data: [],
    };
  },
  components: {
    Back, Loading
  },
  methods: {
    load() {
      this.loading = true;
      api
        .get("/v1/wisuda/CheckinController/getPesertaCheckin")
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    ambilSertifikat(item) {
      if (item.ambil_sertifikat == 1) {
        item.ambil_sertifikat = null;
      } else {
        item.ambil_sertifikat = 1;
      }

      api
        .postJson("/v1/wisuda/CheckinController/ambilSertifikat", {
          id: item.id_wisuda,
          ambil_sertifikat: item.ambil_sertifikat
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.page {
  h3 {
    margin: 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #333;
  }
  .body {
    padding-top: 60px;
    p {
      font-size: 14px;
    }
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        display: grid;
        grid-template-columns: 40px 1fr;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;
        p {
          margin: 0;
          margin-top: 4px;
          font-weight: 600;
        }
        small {
          color: #777;
        }

        table {
          tr {
            td {
              font-size: 14px;
              &:nth-child(1),
              &:nth-child(2) {
                padding-right: 5px;
              }
            }
          }
        }

        &:active {
          background: #eee;
        }
        &.active {
          background: #e7f7e9;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Sertifikat.vue